<template>
  <div>
    <div style="float: left">
      <el-upload class="upload-fee"
                 action=""
                 :before-upload="onFile"
                 multiple>
        <el-button size="small"
                   v-if="!disabled"
                   :disabled="disabled"
                   type="primary">打开json文件</el-button>
      </el-upload>

    </div>
    <div style="float: left; margin-left: 10px">
      <el-button type="info"
                 v-if="!!dd"
                 @click="showDetail"
                 size="small">查看详情</el-button>
    </div>
    <div style="clear: both"></div>

    <el-dialog title="费率表详情"
               :visible.sync="showFeeList"
               width="60%"
               custom-class="fee-list-dialog">
      <div>
        <div style="margin-bottom: 10px"
             class="age-ranges">
          <el-button v-for="(v,idx) of ageGroups"
                     :key="v[0]"
                     @click="displayIndex=idx"
                     size="mini"
                     :type="displayIndex===idx ? 'primary' : '' ">{{v[0]}}-{{v[1]}}岁</el-button>
        </div>

        <el-table width="100%"
                  height="650px"
                  :fit="true"
                  :cell-class-name="'fee-list-cell'"
                  header-cell-class-name='fee-list-header-cell'
                  :stripe="true"
                  :border="true"
                  :data="getDataByAge(displayIndex)"
                  :key="displayKey">
          <el-table-column v-for="(c) in columns"
                           :key="c"
                           :min-width="colWidth(c)"
                           :label="colName(c)"
                           :filters="genFilters(getDataByAge(displayIndex), c)"
                           :filter-method="filterHandler"
                           :formatter="fmt"
                           :prop="c"
                           :sortable="c[0] !== '_'">
            <template slot-scope="s">{{fmt(s.row, c, s.row[c])}}</template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<style scoped>
>>> .fee-list-cell .cell {
  padding: 0 !important;
  text-align: center;
}
>>> .fee-list-cell {
  padding: 0 !important;
}
>>> .fee-list-header-cell {
  padding: 0;
  text-align: center;
}
>>> .fee-list-dialog .el-dialog__body {
  padding-top: 10px;
}
>>> .age-ranges .el-button {
  padding: 7px 10px 7px 10px;
  margin: 0 0 5px 8px;
}
</style>
<script>
import LibProductItem from '../../../minxin/ProductItem';

const gender = {
  MALE: '男',
  FEMALE: '女'
}

const formatter = {
  gender(v) {
    return gender[v] || v
  }
}

export default {
  name: "ProductItemTypeFeeList",
  mixins: [LibProductItem],
  props: {
    value: Array
  },
  data() {
    return {
      showFeeList: false,
      displayIndex: 0,
      displayKey: 0
    }
  },
  computed: {
    options() {
      return this.list || this.ageOptions()
    },
    tableData() {
      return this.dd || []
    },
    ageGroups() {
      let ages = {}
      for (let r of this.tableData) {
        ages[r['age']] = (ages[r['age']] || 0) + 1
      }

      let maxPerPage = 1000

      let ageGroups = []
      let start = -1
      let count = 0
      let last_age = -1
      for (let age of Object.keys(ages).sort((l, r) => { return parseInt(l) - parseInt(r) })) {
        if (start === -1) {
          start = age
        }

        if (count + ages[age] > maxPerPage && count > 0) {
          ageGroups.push([start, last_age])
          count = 0
          start = age
        }
        count += ages[age]
        last_age = age
      }

      if (count > 0) {
        ageGroups.push([start, last_age])
      }

      return ageGroups
    },
    columns() {
      if (this.tableData.length === 0) {
        return []
      }
      let o = {}
      for (let r of this.tableData) {
        o = Object.assign(o, r)
      }

      let columns = ['age', 'gender']
      if ('to_age' in o || 'period' in o) {
        columns.push('__cover')
      }
      if ('payment_period' in o || 'payment_to_age' in o) {
        columns.push('__pay')
      }

      let skips = ['age', 'gender', 'to_age', 'period', 'payment_period', 'payment_to_age', 'fee'];
      for (let k of Object.keys(o)) {
        if (!skips.includes(k)) {
          columns.push(k)
        }
      }

      columns.push('fee')
      return columns
    }
  },
  methods: {
    fmt(r, k, v) {
      if (k in formatter) {
        return formatter[k](v)
      }
      if (k === '__cover') {
        if (r.period > 0) {
          return r.period + '年'
        } else if (r.to_age > 0) {
          return r.to_age > 105 ? '终生' : '至' + r.to_age + '岁'
        }
      } else if (k === '__pay') {
        if (r.payment_period > 0) {
          return r.payment_period + '年'
        } else if (r.payment_to_age > 0) {
          return r.payment_to_age > 105 ? '终生' : '至' + r.payment_to_age + '岁'
        }
      }

      if (v === undefined || v === null) {
        return ''
      }

      return v;
    },
    showDetail() {
      this.showFeeList = true
      this.displayIndex = 0
      this.displayKey = Math.round(Math.random() * 10000000)
    },
    getDataByAge(index) {
      let range = this.ageGroups[index]
      let list = []
      for (let r of this.tableData) {
        if (r['age'] >= range[0] && r['age'] <= range[1]) {
          list.push(r)
        }
      }
      // list.sort((l, r) => {
      //   return (l.age || 0) - (r.age || 0)
      // })
      return list
    },
    genFilters(dataList, k) {
      if (k === 'fee') {
        return []
      }
      let m = {}
      for (let r of dataList) {
        const x = this.fmt(r, k, r[k])
        m[x] = x
      }

      let ret = [];
      for (let t in m) {
        ret.push({ text: t === '' ? '(空)' : t, value: m[t] })
      }

      return ret
    },
    filterHandler(value, row, column) {
      const property = column['property'];
      return this.fmt(row, column['property'], row[property]) == value;
    },
    colWidth(k) {
      const map = {
        gender: '80px',
        age: '120px',
        __pay: '120px',
        __cover: '160px',
        fee: '170px'
      }
      return map[k] || ''
    },
    colName(key) {
      const map = {
        age: '年龄（岁）',
        fee: '费率（万元保费）',
        gender: '性别',
        __cover: '保障期限',
        __pay: '缴费期限',
        social_security: '社保'
      }

      return map[key] || key
    },
    onFile(file) {
      let filename = file.name
      let ext = filename.split('.')
      if (ext[ext.length - 1].toLowerCase() !== 'json') {
        this.$message.error('必须是json格式的文件');
        return
      }

      let reader = new FileReader()
      reader.onloadend = function (evt) {
        if (evt.target.readyState === FileReader.DONE) {
          try {
            this.dd = JSON.parse(evt.target.result)
            this.showFeeList = true
          } catch (e) {
            this.$message.error('费率文件格式错误')
          }
        }
      }.bind(this)
      reader.readAsText(file, 'utf-8')
      return false
    }
  },
}
</script>
